import { collection, doc,getDocs ,setDoc,updateDoc, addDoc, onSnapshot, serverTimestamp } from "firebase/firestore"; 
import { readable } from "svelte/store";
import {db, user} from '../firebase'


export class Task {
    constructor(data) {
        Object.assign(this, data)
        return this
    }


    static create(shop,id, data = {messages:{}}) {
        data.timestamp = serverTimestamp()
        return setDoc(doc(db, "/stores/" + shop + "/tasks",id), data)
    }
    static update(shop,data,id){
        return updateDoc(doc(db,"/stores/" + shop + "/tasks",id),data)
    }

    static async fromShop(shop) {
        /* set converter to convert the .data() to a class directly*/
        let res = await getDocs(collection(db, "/stores/" + shop + "/tasks").withConverter(Task.converters))
        /* convert docs into classes using the converter then return a map of taskID: task */
        return Object.fromEntries(res.docs.map((item) => [item.id, item.data()]))
    }

    static realTime(shop) {
        return readable({}, (set) => {
            const ref = collection(db, "/stores/" + shop + "/tasks").withConverter(Task.converters)
            const unsubscribeSnapshot = onSnapshot(ref, (querySnapShot) => {
                /* we got all the docs returned by the snapshot get their data (which is converted to class)
                    (using the .withConverter) and map the instances with their ID
                */
                const tasks = Object.fromEntries(querySnapShot.docs.map((item) => [item.id, item.data()]))
                console.log(tasks)
                set(tasks)
            })
            return () => unsubscribeSnapshot 
        })
        
    }


    static converters = {
        toFirestore: (task) => {

        },
        fromFirestore: (snapshot, options = {}) => {
            const data = snapshot.data(options);
            return new Task(data)
        }
    }
}